"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketplaceToCxTupleQueryResolver = exports.MarketplaceToCxTupleQueryResolverDevo = void 0;
const offline_query_resolver_1 = __importDefault(require("./offline-query-resolver"));
const marketplaceCXIdMapping_1 = require("@amzn/marketplace-cxid-mapping-typescript/dist/marketplaceCXIdMapping");
const i18n_configuration_provider_1 = require("@amzn/i18n.configuration-provider");
const documents_json_1 = require("@amzn/marketplace-cxid-mapping-config/dist/acs_MarketplaceCXIdMapping/documents.json");
const queries_json_1 = require("@amzn/marketplace-cxid-mapping-config/dist/acs_MarketplaceCXIdMapping/queries.json");
const hierarchical_queries_json_1 = require("@amzn/marketplace-cxid-mapping-config/dist/acs_MarketplaceCXIdMapping/hierarchical_queries.json");
const documents_json_2 = require("@amzn/marketplace-cxid-mapping-config/dist/devo/acs_MarketplaceCXIdMapping/documents.json");
const queries_json_2 = require("@amzn/marketplace-cxid-mapping-config/dist/devo/acs_MarketplaceCXIdMapping/queries.json");
const hierarchical_queries_json_2 = require("@amzn/marketplace-cxid-mapping-config/dist/devo/acs_MarketplaceCXIdMapping/hierarchical_queries.json");
const OfflineClientSettings_1 = __importDefault(require("@amzn/amazon-config-store-type-script-offline-adapter/dist/OfflineClientSettings"));
const ClientStage_1 = __importDefault(require("@amzn/amazon-config-store-model-tscommon/dist/utils/ClientStage"));
/**
 * Resolves queries using the MarketplaceCXIdMapping feature
 * (https://console.harmony.a2z.com/acs-web-editor/features/MarketplaceCXIdMapping).
 */
class MarketplaceToCxTupleQueryResolver extends offline_query_resolver_1.default {
    resolve(attributeName, args) {
        super.validate(attributeName, args);
        return this.doResolve(attributeName, args);
    }
    doResolve(attributeName, args) {
        const marketplaceId = args.obfuscatedMarketplaceId;
        // MarketplaceID is required for MarketplaceId to CxTuple resolution
        // Manual validate is chosen on purpose as specific Exception is part of the API
        if (marketplaceId === undefined) {
            throw new Error('Missing required input ObfuscatedMarketplaceId.');
        }
        // Create the ACS input
        const context = new marketplaceCXIdMapping_1.MarketplaceCXIdMappingContext(marketplaceId);
        const configBuilder = new i18n_configuration_provider_1.I18nConfiguration.Builder();
        switch (attributeName) {
            case i18n_configuration_provider_1.MarketplaceIdToCxTuple.CX_ID:
                const cxId = this.getAcsClient().getCxId(context);
                configBuilder.addConfiguration(i18n_configuration_provider_1.MarketplaceIdToCxTupleResult.CX_ID, cxId);
                break;
            case i18n_configuration_provider_1.MarketplaceIdToCxTuple.CX_FAMILY:
                const cxFamily = this.getAcsClient().getCxFamily(context);
                configBuilder.addConfiguration(i18n_configuration_provider_1.MarketplaceIdToCxTupleResult.CX_FAMILY, cxFamily);
                break;
            default:
                throw new Error(`Attribute name ${attributeName} is not defined for feature ${attributeName.getConfigType()}`);
        }
        return configBuilder.build();
    }
    getTypeSafeClientProvider() {
        return new marketplaceCXIdMapping_1.MarketplaceCXIdMappingClientProvider();
    }
    getAcsClient() {
        return super.acsClient;
    }
    getOfflineConfigFiles() {
        return {
            documents: documents_json_1.documents,
            exactQueries: queries_json_1.queries,
            hierarchicalFallbackQueries: hierarchical_queries_json_1.queries
        };
    }
    getTargetConfigType() {
        return MarketplaceToCxTupleQueryResolver.CONFIG_TYPE;
    }
    getValidationErrorMessage() {
        return `MarketplaceId to CxTuple can only be resolved for configType ${this.getTargetConfigType()}`;
    }
}
exports.MarketplaceToCxTupleQueryResolver = MarketplaceToCxTupleQueryResolver;
MarketplaceToCxTupleQueryResolver.CONFIG_TYPE = i18n_configuration_provider_1.ConfigType.MARKETPLACEID_TO_CX_TUPLE;
class MarketplaceToCxTupleQueryResolverDevo extends MarketplaceToCxTupleQueryResolver {
    getOfflineClientSettings() {
        return new OfflineClientSettings_1.default({
            stage: ClientStage_1.default.DEVO
        });
    }
    getOfflineConfigFiles() {
        return {
            documents: documents_json_2.documents,
            exactQueries: queries_json_2.queries,
            hierarchicalFallbackQueries: hierarchical_queries_json_2.queries
        };
    }
}
exports.MarketplaceToCxTupleQueryResolverDevo = MarketplaceToCxTupleQueryResolverDevo;
//# sourceMappingURL=marketplace-to-cx-tuple-query-resolver.js.map